import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";

const NotFound = () => {
  const history = useHistory();
  return (
    <Box
      sx={{
        width: "100%",
        height: "80vh",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Grid
        container
        flexDirection={"column"}
        sx={{
          justifyContent: "center",
          alignItems: "center",
          gap: "50px",
          height: "100%",
          width: "fit-content",
        }}
      >
        <Grid
          item
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "15px",
            flexDirection: "column",
          }}
        >
          <Box width={"150px"} height={"100px"}>
            <img
              src="images/not-found.png"
              alt="not found"
              style={{ width: "100%", height: "auto", objectFit: "contain" }}
            />
          </Box>
          <Typography sx={{ fontWeight: "bold", fontSize: "1rem" }}>
            خطایی رخ داده!
          </Typography>
          <Typography sx={{ fontSize: "1rem" }}>
            صفحه ای که به دنبال آن هستید یافت نشد!
          </Typography>
        </Grid>
        <Grid item sx={{ width: "100%" }}>
          <Button
            onClick={() => history.push("/")}
            fullWidth
            sx={{
              backgroundColor: "#1565C0",
              color: "#ffffff",
              fontSize: "1rem",
              fontWeight: "500",
              paddingY: "10px",
              "&: hover": { backgroundColor: "#1565C0" },
            }}
          >
            بازگشت به خانه
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NotFound;
